import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, AlertCircle, Loader2, Book, User, Mail } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ConfirmarPagoLibritoPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (token) {
      confirmarPago();
    } else {
      setLoading(false);
      setError('Link inválido. Falta el token de confirmación.');
    }
  }, [token]);

  const confirmarPago = async () => {
    try {
      const response = await axios.get(`${API_URL}/libritos/confirmar-pago`, {
        params: { token }
      });
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al confirmar el pago');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-violet-50 to-white flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-violet-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Confirmando pago...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-violet-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo-colegio.png" alt="Logo" className="h-12 w-auto" />
          </Link>
        </div>
      </header>

      <main className="max-w-lg mx-auto px-4 py-16">
        <Card className="shadow-lg">
          <CardContent className="pt-8 pb-8 text-center">
            {error ? (
              <>
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <AlertCircle className="w-10 h-10 text-red-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Error</h2>
                <p className="text-gray-600 mb-6">{error}</p>
              </>
            ) : result?.already_confirmed ? (
              <>
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <CheckCircle className="w-10 h-10 text-blue-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Pago ya confirmado</h2>
                <p className="text-gray-600 mb-6">{result.message}</p>
              </>
            ) : result ? (
              <>
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <CheckCircle className="w-10 h-10 text-emerald-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">¡Pago Confirmado!</h2>
                <p className="text-gray-600 mb-6">{result.message}</p>
                
                {result.book_title && (
                  <div className="bg-violet-50 border border-violet-200 rounded-lg p-4 mb-6 text-left">
                    <div className="flex items-start gap-3">
                      <Book className="w-5 h-5 text-violet-600 mt-0.5" />
                      <div>
                        <p className="font-medium text-gray-900">{result.book_title}</p>
                      </div>
                    </div>
                    {result.customer_name && (
                      <div className="flex items-start gap-3 mt-3">
                        <User className="w-5 h-5 text-violet-600 mt-0.5" />
                        <p className="text-gray-600">{result.customer_name}</p>
                      </div>
                    )}
                    {result.customer_email && (
                      <div className="flex items-start gap-3 mt-2">
                        <Mail className="w-5 h-5 text-violet-600 mt-0.5" />
                        <p className="text-gray-600 text-sm">{result.customer_email}</p>
                      </div>
                    )}
                  </div>
                )}
                
                <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 text-sm text-emerald-800">
                  <p>Se envió un email al usuario informándole que puede retirar el libro.</p>
                </div>
              </>
            ) : null}

            <div className="mt-8">
              <Link to="/">
                <Button variant="outline">
                  Volver al inicio
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
